import { render, staticRenderFns } from "./PhoneContainer.vue?vue&type=template&id=04202e23&scoped=true&"
import script from "./PhoneContainer.vue?vue&type=script&lang=js&"
export * from "./PhoneContainer.vue?vue&type=script&lang=js&"
import style0 from "./PhoneContainer.vue?vue&type=style&index=0&id=04202e23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04202e23",
  null
  
)

export default component.exports